export const currencyFormatter = (value: number, decimalPlaces?: number): string => {
	let returnItem = '';

	if (!decimalPlaces) {
		decimalPlaces = 0;
	}

	if (value !== null && value !== undefined) {
		returnItem = parseFloat(value.toString().replace(/,/g, ''))
			.toFixed(decimalPlaces)
			.toString()
			.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
			.replace('NaN', '');
	}
	return returnItem;
};

export const convertStringtoDollarString = (value: any): string => {
	if(value > 0) {
		return `$${currencyFormatter(Number(value))}`;
	}
	return '';
};
